import { DateTime } from 'luxon';

import { getAvailableSlots } from 'api';

export const getField = (name, form) => {
  return form.fields.find((x) => x.name === name);
};

export const getMinDateTime = (form) => {
  const { availableSlotsType = null, availableSlotsValue = null } = form?.availableSlotsDetails || {};

  if (availableSlotsType == null) return DateTime.now();

  let minDate = DateTime.now();

  if (availableSlotsType === 0) {
    minDate = minDate.plus({ hours: availableSlotsValue });
  } else if (availableSlotsType === 1) {
    minDate = minDate.plus({ days: availableSlotsValue });
  }

  return minDate;
};

export const filterDate = (date, bookingForm, timeSlotsMap) => {
  const day = date.getDay();
  const formattedDate = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');

  const workingDays = bookingForm.workingSchedule
    .filter((x) => x.isWorkingDay)
    .map((x) => x.weekDay);

  const isWorkingDay = workingDays.includes(day);

  const hasTimeSlots = timeSlotsMap.has(formattedDate) && timeSlotsMap.get(formattedDate).length > 0;

  return isWorkingDay && hasTimeSlots;
};

const handleTimeReset = async (values, setFieldValue) => {
  if (values.customTimeRangeEnabled) {
    await setFieldValue('time', '');
  }
};

export const handleDateChange = async (newDate, setFieldValue, values, updateEventMap) => {
  let selectedDate = newDate;

  if (Array.isArray(selectedDate)) {
    [selectedDate] = selectedDate;
  }

  if (selectedDate instanceof Date) {
    await setFieldValue('date', selectedDate);
    await handleTimeReset(values, setFieldValue);

    updateEventMap(selectedDate);
  }
};

export const getKeyForDate = (date) => `${date.getFullYear()}-${date.getMonth() + 1}`;

// The server returns the slots available on each day of the month, already in the company zone.
export const fetchMonthSlots = async (month, year, values, form, loadedMonths, timeSlotsMap) => {
  const key = `${year}-${month + 1}`;

  if (loadedMonths.has(key)) return;

  const monthStart = DateTime.local(year, month + 1, 1);
  const { data } = await getAvailableSlots(
    values.portalId,
    monthStart.toFormat('yyyy-MM-dd'),
    monthStart.endOf('month').toFormat('yyyy-MM-dd'),
  );

  const fixedTimes = values.customTimeRangeEnabled
    ? null
    : getField('Time', form).options.map((o) => ({ value: o, label: o }));

  data.forEach(({ date, slots }) => {
    timeSlotsMap.set(date, fixedTimes || slots.map((time) => ({ value: time, label: time })));
  });

  loadedMonths.set(key, true);
};
